var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasteSalt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TasteSalt",
    "data-name": "TasteSalt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 112,
    viewBox: "0 0 109 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.135 0.024)",
    opacity: 0.151
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Icon.BG",
    cx: 54.5,
    cy: 56,
    rx: 54.5,
    ry: 56,
    transform: "translate(0.135 -0.024)",
    fill: "#7ab6e2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12638",
    "data-name": "Path 12638",
    d: "M638.7,809a6.649,6.649,0,0,0-6.972,4.011c-1.268,2.975-.387,6.437,2.382,6.761s6.377-2.613,7.644-5.588-.285-4.861-3.054-5.185",
    transform: "translate(-574.313 -774.45)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12639",
    "data-name": "Path 12639",
    d: "M638.7,809a6.649,6.649,0,0,0-6.972,4.011c-1.268,2.975-.387,6.437,2.382,6.761s6.377-2.613,7.644-5.588-.285-4.861-3.054-5.185",
    transform: "translate(-568.792 -756.066)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12640",
    "data-name": "Path 12640",
    d: "M638.7,809a6.649,6.649,0,0,0-6.972,4.011c-1.268,2.975-.387,6.437,2.382,6.761s6.377-2.613,7.644-5.588-.285-4.861-3.054-5.185",
    transform: "translate(-591.793 -758.317)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12641",
    "data-name": "Path 12641",
    d: "M638.7,809a6.649,6.649,0,0,0-6.972,4.011c-1.268,2.975-.387,6.437,2.382,6.761s6.377-2.613,7.644-5.588-.285-4.861-3.054-5.185",
    transform: "translate(-582.185 -739.427)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasteSalt);
export default __webpack_public_path__ + "static/media/TasteSalt.7fd86e0c2d4fb59090f57127fb744920.svg";
export { ForwardRef as ReactComponent };